"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partialWithoutDefaults = partialWithoutDefaults;
const zod_1 = require("zod");
function partialWithoutDefaults(schema) {
    const shape = {};
    for (const [key, field] of Object.entries(schema.shape)) {
        const inner = field instanceof zod_1.z.ZodDefault || field instanceof zod_1.z.ZodPrefault ? field.unwrap() : field;
        const description = field instanceof zod_1.z.ZodType ? field.description : undefined;
        const optional = zod_1.z.optional(inner);
        shape[key] = description === undefined ? optional : optional.describe(description);
    }
    const extended = schema.extend(shape);
    const relaxed = schema.description === undefined ? extended : extended.describe(schema.description);
    return relaxed;
}
//# sourceMappingURL=zod-partial.js.map